import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IMatterRequest } from '../interface/matterRequest';
import { Entities } from '../interface/common';

interface IFetchMatterRequestsById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useFetchMatterRequestsById = (params: IFetchMatterRequestsById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const matterRequestUrl = `${API_URLS.CREATE_MATTER_REQUEST}/${id}`;
  const url = queryString ? `${matterRequestUrl}?${queryString}` : matterRequestUrl;
  const query = useQuery<IMatterRequest, Error>({
    queryKey: ['matter-requests-details', id],
    queryFn: async () => {
      const response = await get(
        url,
        {},
        {
          headers: {
            entity: Entities.MATTERREQUEST,
          },
        },
      );
      return response;
    },
    enabled: !!id,
  });

  return query;
};
